import { Switch } from "../../../../components/Switch";
import Button from "../../../../components/Button/Button";
import { Modal } from "../../../../components/Modal";
import { useState } from "react";
import { useTranslation } from 'react-i18next';

export const ArchivedStoresList = ({ stores = [] }) => {
    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);
    const [isPopupOpened, setIsPopupOpened] = useState(false);
    return (
        <div className="flex flex-col">
            <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                    <table className="min-w-full " style={{ borderSpacing: '0 12px' }}>
                        <thead>
                            <tr>
                                <th scope="col" className="pl-4 py-3 text-sm font-bold text-left">
                                    {t('Name')}
                                </th>
                                <th scope="col" className="py-3 text-sm font-bold text-left">
                                    {t('Address')}
                                </th>
                                <th scope="col" className="py-3 text-sm font-bold text-left">
                                    {t('Open/Close')}
                                </th>
                                <th scope="col" className="py-3 text-sm font-bold text-left">
                                    <span className="sr-only">{t('Edit')}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {stores.map(({ address, name, id }) => (
                                <tr key={id} className="rounded-lg bg-white py-4 border-b">
                                    <td className="w-1/3 whitespace-nowrap pl-4 py-4 text-sm font-medium text-gray-900">{name}</td>
                                    <td className="whitespace-nowrap lg:whitespace-normal py-4 text-sm text-gray-500">{address}</td>
                                    <td className="whitespace-nowrap py-4 text-sm text-gray-500">
                                        <div className="group relative">
                                            <Switch onChange={() => {}} isEnabled={false} />
                                            {/*<div className="hidden group-hover:block absolute bottom-2 p-4 bg-gray-200">*/}
                                            {/*    <p>*/}

                                            {/*    You cannot open an archived store while it remains non-active.*/}
                                            {/*    </p>*/}

                                            {/*    Please first activate this store to make any changes.*/}
                                            {/*</div>*/}
                                        </div>
                                    </td>
                                    <td className="w-20 relative whitespace-nowrap py-3 pl-3 text-right text-sm font-medium sm:pr-6 md:pr-3">
                                        <Button
                                            onClick={() => setIsOpen(true)}
                                            className="whitespace-nowrap h-9 inline-flex items-center rounded-lg border border-transparent bg-purple-500 text-sm font-bold text-white shadow-sm hover:bg-purple-600 focus:outline-none"
                                        >
                                            Activate
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <Modal setIsOpen={setIsOpen} isOpen={isOpen}>
                <Button
                    onClick={() => setIsOpen(false)}
                    className="whitespace-nowrap h-9 inline-flex items-center rounded-lg border border-transparent bg-purple-500 text-sm font-bold text-white shadow-sm hover:bg-purple-600 focus:outline-none"
                >
                    close
                </Button>
            </Modal>
        </div>
    );
};
